export const flightResultsRootRoute = 'flight-results';
export const routeDetail = 'route-detail';
export const filtersRoute = 'filters';
export const singleFilterRoute = 'single-filter';
export const calendarRoute = 'calendar';
export const flexiDatesRoute = 'flexi-dates';
export const flightUpsellRoute = 'upsell';
export const flightUpsellBySectorRoute = 'upsell-by-sector';
